var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mypage-user-confirm-pane"},[_c('user-confirm-form-section',{ref:"userConfirmFormSection",on:{"success-regist":_vm.regist}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }